import React, { ReactNode } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

interface Props {
  children: ReactNode
  scriptProps?: {
    nonce?: string
    defer?: boolean
    async?: boolean
    appendTo?: 'head' | 'body' | undefined
    id?: string
    onLoadCallbackName?: string
  }
}

const CaptchaProvider: React.FunctionComponent<Props> = ({
  children,
  scriptProps = {},
}) => (
  <GoogleReCaptchaProvider
    scriptProps={scriptProps}
    container={{
      parameters: {
        badge: 'bottomleft',
      },
    }}
    reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY || ''}
  >
    {children}
  </GoogleReCaptchaProvider>
)

export default CaptchaProvider
